import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import { TextField, Grid, Button } from "@material-ui/core";
import axios from "axios";
import HelloSign from "hellosign-embedded";
import { makeStyles } from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";
import { useDropzone } from "react-dropzone";
import { FiUpload } from "react-icons/fi";
import { ClipLoader } from "react-spinners";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      display: "flex",
      justifyContent: "center",
      margin: "40px auto",
      textAlign: "center",
      [theme.breakpoints.down(768)]: {
        margin: "32px auto",
      },
      "& label": {
        color: "#5C5C5C",
      },
    },
  },
  heading: {
    fontSize: 32,
    fontWeight: 700,
    marginTop: 16,
    marginBottom: 16,
    [theme.breakpoints.down(768)]: {
      fontSize: 24,
    },
  },
}));

export default function TemplateModal(props) {
  const classes = useStyles();

  const { template, notify } = props;
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTitle(template.title);
  }, [template]);

  const handleClose = () => {
    props.setOpen(false);
  };

  function updateTemplate() {
    setLoading(true);
    const { firmId, templateId } = props;

    axios
      .put("/template/update", { firmId, templateId, title })
      .then((resp) => {
        console.log("Template updated", resp);
        props.setOpen(false);
        let arr = [...props.templates];
        let index = arr.findIndex((el) => el.id == props.templateId);
        arr[index].title = title;
        props.setTemplates([...arr]);
        setLoading(false);
        notify("Template title updated!", true);
      })
      .catch((err) => {
        setLoading(false);
        console.log(
          "Error updating template",
          err.response ? err.response : err
        );
        notify("Issue updating template. Please try again later.", false);
      });
  }

  return (
    <Modal
      open={props.open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{ margin: "1rem" }}
      onClick={handleClose}
    >
      <div className="modal">
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-form">
            <div className={classes.root}>
              <ClearIcon className="close" onClick={handleClose} />
              <h2 className={classes.heading}>Update a Template</h2>
              <TextField
                variant="outlined"
                disableUnderline={true}
                fullWidth
                label="Template Name"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={{
                  flex: 0.6,
                  color: "#000",
                  borderRadius: "100px",
                }}
                inputProps={{ style: { textTransform: "capitalize" } }}
              />
              <Button
                className="btn light-blue add-btn"
                disabled={!title}
                onClick={() => updateTemplate()}
              >
                {loading ? (
                  <div
                    className="sweet-loading"
                    style={{
                      position: "absolute",
                      width: 15,
                      height: 15,
                      top: 13,
                    }}
                  >
                    <ClipLoader size={20} color="#fff" loading={loading} />
                  </div>
                ) : (
                  <span>Update Template</span>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
